import { DepositStatisticType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const depositStatisticTypeName: { [key in DepositStatisticType]: TKeyType } = {
  [DepositStatisticType.GOLDEN]: 'common.onlineDeposit2',
  [DepositStatisticType.THIRD_PARTY]: 'common.depositPlatformDeposit'
}

export default depositStatisticTypeName
